import { makeAutoObservable } from "mobx";
import { isValidPassword } from "@/util/validators";

export class PasswordChange {
  constructor(
    public oldPassword?: string,
    public newPassword?: string,
  ) {
    makeAutoObservable(this);
  }

  public isEntered(password?: string) {
    return (password?.length || 0) > 0;
  }

  public get isNewPasswordValid() {
    return (
      this.isEntered(this.newPassword) &&
      isValidPassword(this.newPassword || "")
    );
  }

  public get canSubmit() {
    return this.isNewPasswordValid && this.isEntered(this.oldPassword);
  }
}
